import { invoiceService } from '../../services';

// initial state
const state = {
    list: [],
    status: [],
};

// getters
const getters = {};

// actions
const actions = {
    list ({ dispatch, commit }, data) {
        return invoiceService
            .list(data)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    pdf ({ dispatch }, id) {
        return invoiceService
            .pdf(id)
            .then((nodes) => nodes)
            .catch((error) => {
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

};

// mutations
const mutations = {
    setList (state, nodes) {
        state.list = nodes;
    },

    // add
    addRequest (state) {
        state.status = { adding: true };
    },
    addSuccess (state) {
        state.status = { added: true };
    },
    addFailure (state) {
        state.status = {};
    },

    // update
    updateRequest (state) {
        state.status = { updating: true };
    },
    updateSuccess (state) {
        state.status = { updated: true };
    },
    updateFailure (state) {
        state.status = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
